<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-commission-item-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Commission Item
            </h4>
          </div>

          <LoadingSpinner v-if="loading"/>

          <div v-else class="modal-body">
            <TextFormGroup
                v-model="data.value"
                name="value"
                label="Value"
                :error="getError('value')"
            />

            <DateFormGroup
                v-model="data.month"
                name="month"
                label="Month"
                help-text="The month the commission should be added."
                :error="getError('month')"
                format="MM.YYYY"
            />

            <TextFormGroup
                v-model="data.commission_description"
                name="commission_description"
                label="Commission Description"
                :error="getError('commission_description')"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {LoadingSpinner, DateFormGroup, SelectFormGroup, TextFormGroup, TypeaheadFormGroup},

  mixins: [Errors],

  props: {
    commissionItem: {}
  },

  data() {
    return {
      data: {},

      portals: null,

      loading: true,
      shared: store
    }
  },

  watch: {
    commissionItem() {
      this.data = {...this.commissionItem.attributes}
    }
  },

  mounted() {
    this.listenForClose()

    http.get('/api/v2/portals')
        .then(response => {
          this.portals = response.data.data

          this.loading = false
        })
  },

  computed: {
    portalOptions() {
      return this.portals.map(portal => {
        return {
          value: portal.id,
          label: portal.attributes.name
        }
      })
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/commission-items/' + this.commissionItem.id, this.data)
          .then(response => {
            notify.success('The commission item was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {...this.commissionItem}
    }
  }
}
</script>
